import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';

import { MaintenanceExpenseHistoryRoutingModule } from './maintenance-expense-history-routing.module';
import { MaintenanceExpenseHistoryComponent } from './maintenance-expense-history.component';
import { UnitIntelligenceModule } from '../unit-intelligence/unit-intelligence.module';

@NgModule({
    declarations: [
        MaintenanceExpenseHistoryComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        MaintenanceExpenseHistoryRoutingModule,
        NgxSpinnerModule,
        UnitIntelligenceModule,
    ]
})
export class MaintenanceExpenseHistoryModule { }
